var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgWeb = function SvgWeb(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_122_8154)"
  }, /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip1_122_8154)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M14.866 12.018h3.38c.187-.877.281-1.55.281-2.019 0-.47-.094-1.142-.281-2.019h-3.38c.094.657.14 1.33.14 2.019 0 .689-.046 1.362-.14 2.019Zm-1.784 5.54c.782-.251 1.596-.728 2.441-1.433.846-.704 1.487-1.416 1.925-2.136h-2.957a14.643 14.643 0 0 1-1.408 3.568h-.001Zm-.235-5.54c.095-.657.142-1.33.142-2.019 0-.689-.047-1.362-.142-2.019H8.152c-.094.657-.14 1.33-.14 2.019 0 .689.046 1.362.14 2.019h4.696ZM10.5 17.98c.877-1.283 1.518-2.613 1.925-3.99h-3.85c.407 1.377 1.048 2.707 1.925 3.99ZM6.51 6.009c.376-1.346.845-2.535 1.408-3.568-.782.25-1.604.727-2.465 1.432-.86.704-1.494 1.416-1.9 2.136H6.51Zm-2.957 7.98c.406.72 1.04 1.432 1.9 2.136.861.705 1.683 1.182 2.465 1.432A14.586 14.586 0 0 1 6.51 13.99H3.553Zm-.799-1.971h3.38a14.219 14.219 0 0 1-.14-2.019c0-.689.046-1.362.14-2.019h-3.38c-.187.877-.281 1.55-.281 2.019 0 .47.094 1.142.281 2.019Zm7.746-10c-.877 1.283-1.518 2.613-1.925 3.99h3.85c-.407-1.377-1.048-2.707-1.925-3.99Zm6.948 3.991c-.438-.72-1.08-1.432-1.925-2.136-.845-.705-1.659-1.182-2.441-1.432.563 1.033 1.033 2.222 1.408 3.568H17.448ZM10.5 0c2.754 0 5.11.978 7.066 2.934C19.522 4.891 20.5 7.246 20.5 10c0 2.754-.978 5.11-2.934 7.066C15.609 19.022 13.254 20 10.5 20c-2.754 0-5.11-.978-7.066-2.934C1.478 15.109.5 12.754.5 10c0-2.754.978-5.11 2.934-7.066C5.391.978 7.746 0 10.5 0Z",
    fill: "#4285F4"
  })))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_122_8154"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(.5)",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip1_122_8154"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(.5)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgWeb;